// NOTIF-1 — util Web Push no cliente. Pede permissão SÓ no clique, cria/renova
// subscription no PushManager e manda para o backend. Também sabe reconhecer
// quando iOS exige PWA instalada (standalone) para funcionar.
import api from "@/lib/api";

const DEVICE_KEY = "mpires_push_device_id";
const SOM_KEY = "mpires_push_sino_som";

function uuid() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return "d-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = uuid();
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return "fallback-" + Date.now();
  }
}

export function isSupported() {
  return typeof window !== "undefined"
    && "serviceWorker" in navigator
    && "PushManager" in window
    && "Notification" in window;
}

export function isIOS() {
  const ua = (navigator.userAgent || navigator.vendor || "").toLowerCase();
  return /iphone|ipad|ipod/.test(ua) || (ua.includes("macintosh") && "ontouchend" in document);
}

export function isStandalone() {
  // iOS Safari expõe navigator.standalone; outros usam display-mode.
  if (typeof window === "undefined") return false;
  if (window.navigator && window.navigator.standalone === true) return true;
  try { return window.matchMedia("(display-mode: standalone)").matches; } catch { return false; }
}

export function permissionStatus() {
  try { return Notification.permission; } catch { return "default"; }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

/** Pede permissão (precisa ser chamado dentro de um clique!) e registra
 *  a subscription deste aparelho no backend. Devolve resumo. */
export async function enablePush() {
  if (!isSupported()) throw new Error("Este aparelho/navegador não suporta notificações push.");
  if (isIOS() && !isStandalone()) {
    throw new Error("No iPhone, abra o CRM pelo atalho na Tela de Início para ativar notificações.");
  }
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error(permission === "denied"
      ? "Permissão negada. Habilite nas configurações do navegador."
      : "Permissão não concedida.");
  }
  const { data } = await api.get("/webpush/public-key");
  const applicationServerKey = urlBase64ToUint8Array(data.public_key);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
  }
  const json = sub.toJSON();
  await api.post("/webpush/subscribe", {
    device_id: getDeviceId(),
    endpoint: json.endpoint,
    keys: json.keys,
    user_agent: navigator.userAgent || "",
  });
  return { ok: true };
}

export async function disablePush() {
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (reg) {
      const sub = await reg.pushManager.getSubscription();
      if (sub) await sub.unsubscribe();
    }
  } catch { /* ignora */ }
  try {
    await api.post("/webpush/unsubscribe", {
      device_id: getDeviceId(),
      endpoint: "", keys: { p256dh: "x", auth: "x" },
    });
  } catch { /* ignora */ }
}

export async function sendTestPush() {
  await api.post("/webpush/test", {});
}

export async function statusPush() {
  try {
    const { data } = await api.get("/webpush/status");
    return data;
  } catch { return { inscritos: 0 }; }
}

// ------- Som do sino (preferência local, por aparelho) -------
export function getSomSinoAtivo() {
  try { return localStorage.getItem(SOM_KEY) !== "off"; } catch { return true; }
}
export function setSomSinoAtivo(ativo) {
  try { localStorage.setItem(SOM_KEY, ativo ? "on" : "off"); } catch (e) { void e; }
}
